import React, {useEffect, useState} from 'react';
import {Provider} from "mobx-react";
import Layout from './src/layout';
import './src/styles/global.scss';
import LandingAppStore from "./src/store/appStore";
import LandingKafkaStore from "./src/store/kafkaStore";
import {brandContext} from "./src/store/brandContext";
import {IS_SERVER} from "./src/common";
import PreLoader from "./src/components/templateElements/loader";

const RootElement = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  require('./src/fontawesome');

  let brandName = 'zenit';

  if (!IS_SERVER) {
    if (/zenit/.test(window.location.pathname)) {
      brandName = 'zenit';
    } else if (/zenbet/.test(window.location.pathname)) {
      brandName = 'zenbet';
    } else if (/cupis/.test(window.location.pathname)) {
      brandName = 'cupis';
    }
  }

  const onClientEntry = async () => {
    if (typeof IntersectionObserver === "undefined") {
      await import("intersection-observer");
    }
  };

  useEffect(() => {
    window.location.pathname === '/' && setIsLoading(false);
    if (!IS_SERVER) {
      document.body.style.backgroundColor = '#27587b';
    }
    setTimeout(() => {
      setIsLoading(false);
      if (!IS_SERVER) {
        document.body.style.backgroundColor = 'inherit';
      }
    }, 600);
    const fixLazyLoading = onClientEntry();
    return fixLazyLoading;
  }, []);

  return (
    <brandContext.Provider value={brandName}>
      <Provider appStore={LandingAppStore} kafkaStore={LandingKafkaStore}>
        {isLoading
          ? <PreLoader />
          : props.element
        }
      </Provider>
    </brandContext.Provider>
  )
}

const Wrapper = ({ element }) => <RootElement element={element} />

export const wrapRootElement = Wrapper;

export const wrapPageElement = ({element, props}) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Layout {...props}>
    {element}
  </Layout>
);

// export const onInitialClientRender = () => {
//   window.onload = () => {
//     document.querySelector('.Preloader').remove()
//   }
// };
